// extracted by mini-css-extract-plugin
export default {"premiumContainer":"GetSubscriptionCard_premiumContainer__zncJ7"};